import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  data: [],
  apiError: null,
  isFetching: false,
};

const beforeRequest = () => ({ ...initialState, isFetching: true });

const onFail = (state, { payload: apiError }) => ({
  data: [],
  isFetching: false,
  apiError,
});

const onSuccess = (state, { payload: data }) => ({
  ...state,
  data,
  isFetching: false,
});

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_SEVERITY]: beforeRequest,
  [types.FETCH_STATISTICS_SEVERITY_SUCCESS]: onSuccess,
  [types.FETCH_STATISTICS_SEVERITY_FAILURE]: onFail,
});
